import { render } from "./NewsComp.vue?vue&type=template&id=57d1e684&scoped=true"
import script from "./NewsComp.vue?vue&type=script&lang=js"
export * from "./NewsComp.vue?vue&type=script&lang=js"

import "./NewsComp.vue?vue&type=style&index=0&id=57d1e684&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxwhcy\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d1e684"]])

export default __exports__